export default "__VITE_ASSET__D4i_CeGv__"